import { createPermission } from '@backstage/plugin-permission-common';

export const serviceRestartPermission = createPermission({
  name: 'fondative.service.restart',
  attributes: { action: 'update' },
});

export const serviceRollbackPermission = createPermission({
  name: 'fondative.argocd.rollback',
  attributes: { action: 'update' },
});

export const dbDumpPermission = createPermission({
  name: 'fondative.db.dump',
  attributes: { action: 'read' },
});

export const serviceCacheClearPermission = createPermission({
  name: 'fondative.service.cache-clear',
  attributes: { action: 'update' },
});

export const envManagerEditPermission = createPermission({
  name: 'fondative.env.edit',
  attributes: { action: 'update' },
});

export const cronjobManagePermission = createPermission({
  name: 'fondative.cronjob.manage',
  attributes: { action: 'update' },
});

export const dbBackupManagePermission = createPermission({
  name: 'fondative.db.backup',
  attributes: { action: 'update' },
});
